/**
 * @Author  : Luo
 * @Time    : 2020/4/16 15:40
 * config of svg
 */

'use strict'

import Vue from 'vue'
import SvgIcon from '@/components/icon-svg'

// register globally（注册全局组件）
Vue.component('svg-icon', SvgIcon)

// import all *.svg（导入svg目录下所有的.svg文件）
const req = require.context('./svg', false, /\.svg$/)

// all modules that match（返回匹配的所有模块）
const requireAll = requireContext => requireContext.keys().map(requireContext)

// add el of svg in dom（在dom树添加该svg：（组合svg，相当于雪碧图的效果））
requireAll(req)



// WEBPACK FOOTER //
// ./src/assets/icon/index.js